import { useCallback } from 'react';

import { useAppDispatch } from 'app/hooks';
import { ColumnDefinition } from 'common/types/TypeDefs';

import { clearColumnVisibilityOverrides, setColumnVisibilityOverrides } from './columnSettingsSlice';
import { clearStoredVisibility, ColumnVisibilityModel, extractOverrides, writeStoredVisibility } from './columnVisibilityStorage';

/*
    Applies a visibility model to a grid and remembers it. Only the columns that differ
    from their default are kept, so a grid back at its defaults leaves nothing behind.
*/
export const useCommitColumnVisibility = (gridKey: string, columnDefinitions: ColumnDefinition[]) => {
    const dispatch = useAppDispatch();

    return useCallback((model: ColumnVisibilityModel) => {
        const overrides = extractOverrides(columnDefinitions, model);

        if (Object.keys(overrides).length === 0) {
            clearStoredVisibility(gridKey);
            dispatch(clearColumnVisibilityOverrides(gridKey));

            return;
        }

        writeStoredVisibility(gridKey, overrides);
        dispatch(setColumnVisibilityOverrides({ gridKey, overrides }));
    }, [columnDefinitions, dispatch, gridKey]);
};
